import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Unipile from "@/services/unipile/unipile";
import type { CreateWhatsAppChatParams } from "./types";

/**
 * Composable for creating WhatsApp chats using TanStack Query
 */
export function useCreateWhatsAppChat() {
  const queryClient = useQueryClient();

  const createChatMutation = useMutation({
    mutationFn: async (params: CreateWhatsAppChatParams) => {
      const response = await Unipile.createGroupChat(params);

      if (!response.data?.status) {
        const errorData = response.data as any;
        throw new Error(
          errorData?.message || errorData?.errorMessage || errorData?.msg || "Failed to create chat"
        );
      }

      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["whatsapp-conversations"],
      });
    },
  });

  return {
    createChat: createChatMutation.mutateAsync,
    isCreating: createChatMutation.isPending,
    createError: createChatMutation.error,
  };
}
